import { jsx as _e } from "react/jsx-runtime";
import { CUSTOM_CELLS_WITH_SELECT_INLINE_EDIT as Ee, CUSTOM_CELL_MAX_WIDTH as Se, CUSTOM_CELL_MIN_WIDTH as Ie, CUSTOM_CELLS_WITH_SELECT_OPTIONS as pe, CHECKBOX_SELECTION_COLUMN as Le, DRAG_AND_DROP_COLUMN as de, CUSTOM_CELLS_WITH_NO_INLINE_EDIT as Oe, CUSTOM_CELLS_WITH_NO_HEADER as We } from "./index.es594.js";
import { getCustomCelling as w } from "./index.es752.js";
import { getClassNamesForCellsAndHeaders as G } from "./index.es753.js";
import { getTooltipHandling as R } from "./index.es754.js";
import { getCustomValueSettersAndGetters as F } from "./index.es755.js";
import { getMaxWidth as he, getMinWidth as He } from "./index.es756.js";
import { getCustomCellingComponents as be } from "./index.es757.js";
const Ge = (_, E, k, S, I = [], p = []) => {
  const {
    filter: L = !0,
    filterParams: z,
    checkboxSelection: r = !1,
    headerCheckboxSelection: B = !0,
    rowDrag: d = !1,
    sortable: K = !0,
    editable: V = !1,
    numericConfigurations: j,
    resizable: v = !0,
    wrapText: X = !0,
    wrapHeaderText: m = !1,
    propsToDrill: u = {},
    loadingRows: O,
    loading: n
  } = k || {}, W = _.filter(({ pinned: i, cellType: a }) => {
    const l = a || "";
    return !(p.includes(l) || I.includes(l) || i !== void 0);
  }).map(({ field: i }) => i), o = _.map(
    ({ cellType: i, pinned: a, validation: l, additionalInfo: f, ...e }, h) => {
      var U;
      const {
        field: c = "",
        headerComponent: C = {},
        getTooltipText: H,
        customTooltipComponent: b,
        children: g
      } = e, { indicator: q = "Cell", validator: J } = l || {}, Q = q === "Cell", s = i || "", T = We.includes(s), Y = Oe.includes(s), M = Ee.includes(s) || ((U = e.inlineEditSelectOptions) == null ? void 0 : U.length), N = p.includes(s) || a === "right", x = I.includes(s) || a === "left", Z = e.maxWidth || Se[s], $ = e.minWidth || Ie[s], D = d && h === 0, P = r && h === 0, ee = He($, D, P), te = he(Z, D, P), se = M ? "agSelectCellEditor" : void 0, ne = M ? {
        values: pe[s] || e.inlineEditSelectOptions
      } : void 0, oe = Object.values(C)[0], { HeaderComponent: y } = be({ headerComponent: C }), { valueGetter: ie, valueSetter: le } = F(
        c,
        s
      ), re = W[W.length - 1] === c, ae = Y || n || e.loading, ce = T || re, me = e.filter || (L === !0 ? "agTextColumnFilter" : L), A = {
        pinned: N ? "right" : x ? "left" : void 0,
        lockPinned: N || x,
        filter: T ? !1 : me,
        sortable: T ? !1 : e.sortable ?? K,
        editable: ae ? !1 : e.editable ?? V,
        resizable: ce ? !1 : e.resizable ?? v,
        filterParams: { maxNumConditions: 1, ...z }
      };
      return {
        ...e,
        minWidth: ee,
        maxWidth: te,
        cellEditor: se,
        cellEditorParams: ne,
        valueGetter: ie,
        valueSetter: le,
        wrapHeaderText: m,
        autoHeaderHeight: m,
        wrapText: X,
        ...A,
        children: g == null ? void 0 : g.map((t) => {
          const { indicator: ue = "Cell", validator: fe } = t.validation || {}, Ce = ue === "Cell", { valueGetter: ge, valueSetter: Te } = F(
            t.field,
            t.cellType
          );
          return {
            ...t,
            ...G(
              r,
              E,
              S,
              Ce ? fe : void 0,
              t.blur,
              t.field
            ),
            ...w({
              headerComponent: t.headerComponent,
              cellType: t.cellType,
              field: t.field,
              propsToDrill: u,
              wrapHeaderText: m,
              menuItems: t == null ? void 0 : t.menuItems,
              loadingRows: O,
              loading: n,
              additionalInfo: f
            }),
            ...A,
            ...R(
              H,
              t.validation,
              b
            ),
            valueGetter: ge,
            valueSetter: Te
          };
        }),
        filterParams: { maxNumConditions: 1 },
        ...R(H, l, b),
        ...G(
          r,
          E,
          S,
          Q ? J : void 0,
          e.blur,
          c
        ),
        ...w({
          headerComponent: C,
          cellType: s,
          field: c,
          propsToDrill: u,
          menuItems: e == null ? void 0 : e.menuItems,
          loadingRows: O,
          loading: n,
          additionalInfo: f,
          numericConfigurations: e.numericConfigurations || j
        }),
        headerGroupComponentParams: oe,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        headerGroupComponent: (t) => y ? /* @__PURE__ */ _e(
          y,
          {
            ...t,
            ...u,
            menuItems: e.menuItems
          }
        ) : null,
        type: s
      };
    }
  );
  return r && !n && (o[0] = {
    ...o[0],
    headerCheckboxSelection: B,
    ...Le
  }), d && !n && (o[0] = { ...o[0], ...de }), o;
};
export {
  Ge as generateColDefs
};
//# sourceMappingURL=index.es599.js.map
